import { Box, Button, Divider, styled, Typography } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { createFileRoute, useSearch, useNavigate } from '@tanstack/react-router'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import AndroidIcon from 'icons/Technologies/Android.icon';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
// import { Route as AdminInterviewFromScratchRoute } from './_admin.admin-interview-from-scratch'
import useMainStore from '../../store/useMainStore'
import dayjs, { Dayjs } from 'dayjs'
import { useEffect, useMemo, useState } from 'react'
import userInviteStore from 'store/userInviteStore';
import { toast } from 'react-toastify';
import NoData from 'icons/NoData.icon';

interface Interview {
    id: string;
    name: string;
    createdOn: string;
    readTime?: number;
    answerTime?: number;
}

export const Route = createFileRoute(
  '/(partner)/_partner/create-interview-step2',
)({
  component: RouteComponent,
})

const AdvancedInterview = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    backgroundColor: '#fff',
    boxShadow: '0px 1px 2px 0px #0205111A',
    border: '1px solid var(--Light-Gray)',
    borderRadius: '12px',
    padding: '24px',
    width: 'fit-content'
})

const FromScratchInterview = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    backgroundColor: 'var(--Light-Gray)',
    boxShadow: '0px 1px 2px 0px #0205111A',
    border: '1px solid var(--Light-Gray)',
    borderRadius: '12px',
    padding: '24px',
    width: 'fit-content'
})

function RouteComponent() {
  const search = useSearch({ from: '/(partner)/_partner/create-interview-step2' });
  const navigate = useNavigate();


  const inviteDeadlineISO = useMainStore.use.inviteDeadlineISO()
  const setInviteDeadlineISO = useMainStore.use.setInviteDeadlineISO()
  const setInviteInterviewId = useMainStore.use.setInviteInterviewId()
  const setInviteReadTime = useMainStore.use.setInviteReadTime()
  const setInviteAnswerTime = useMainStore.use.setInviteAnswerTime()
  // const [deadlineError, setDeadlineError] = useState<string | null>(null)
  const minSelectableDate = useMemo(() => dayjs().add(1, 'day').startOf('day'), [])



  //novo 
  const tomorrow = dayjs().add(1, 'day');
  const [deadline, setDeadline] = useState('');
  // const [deadlineError, setDeadlineError] = useState('');
  const {userData, updateUserData} = userInviteStore();
  const category = (search as any).category;
  const techId = (search as any).techId;


  // Hide sections based on category
  const shouldHideFromScratch = category === 'all-technologies';
  const shouldHideAdvancedGenerator = category === 'main-organization';

  useEffect(() => {
    console.log('store', userData);
  }, [userData]);

  // Fetch interviews data when techId is available
  const { data: interviews, isLoading: isLoadingInterviews, error: errorInterviews } = useQuery({
    queryKey: ['interviews', techId],
    queryFn: async () => {
      if (!techId) return [];
      const token = localStorage.getItem('token');
      const response = await axios.get(`https://interviewer.runasp.net/api/technologies/${techId}/interviews`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data as Interview[];
    },
    enabled: !!techId,
  });

  const handleAdvancedGeneratorClick = () => {
    if (!deadline) {
      toast.error('Interview deadline is required')
      return
    } else {
      updateUserData({
        deadline: deadline,
      })
      navigate({
        to: '/interview-generator-step1',
        search: {
          techId: techId
        }
      });
    }
  };

  // const ensureDeadline = () => {
  //   if (!inviteDeadlineISO) {
  //     setDeadlineError('Interview deadline is required.')
  //     return false
  //   }

  //   const isFuture = dayjs(inviteDeadlineISO).isAfter(dayjs(), 'day')
  //   if (!isFuture) {
  //     setDeadlineError('Please select a future interview deadline to continue.')
  //     return false
  //   }

  //   setDeadlineError(null)
  //   return true
  // }

  const handleFromScratchClick = () => {
    if (!deadline) {
      toast.error('Interview deadline is required')
      return
    }else {
      updateUserData({
        deadline: deadline,
      })
      navigate({
        to: '/interview-from-scratch',
      })
    }
  }

  // const setAppropriateDate = (value:string) => {
  //   if(!value){
  //     toast.error('Interview deadline is required')
  //   }
  //   console.log(value);
  //   // 2025-12-17T00:00:00.000Z
  //   setDeadline(value)
  // }


  const setAppropriateDate = (value: string | null) => {
    if (!value) {
      toast.error('Interview deadline is required');
      return;
    }

    console.log(value); // 2025-12-17T00:00:00.000Z
    setDeadline(value);
  };

  // const handleDeadlineChange = (value: Dayjs | null) => {
  //   if (!value) {
  //     setInviteDeadlineISO(null)
  //     setDeadlineError('Interview deadline is required.')
  //     return
  //   }

  //   if (!value.isAfter(dayjs(), 'day')) {
  //     setInviteDeadlineISO(null)
  //     setDeadlineError('Please select a future interview deadline to continue.')
  //     return
  //   }

  //   setInviteDeadlineISO(value.startOf('day').toDate().toISOString())
  //   setDeadlineError(null)
  // }

  const handlePredefinedInterviewClick = (interview: Interview) => {
    if(!deadline) {
      toast.error('Interview deadline is required')
      return
    } else {
      updateUserData({
        deadline: deadline,
        interviewId: interview.id
      })
      navigate({
        to: '/invite-user'
      })
    }
  };

  return (
    <Box sx={{maxWidth: '80%', mx: 'auto'}}>
        <Typography variant='h1' sx={{textAlign: 'center', pb: '24px'}}>Add some essential information</Typography>
        <Box
          component="form"
          noValidate
          onSubmit={(event) => event.preventDefault()}
          sx={{ display: 'flex', justifyContent: 'center' }}
        >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                {/* <DatePicker 
                    label="Interview deadline (MM/DD/YY)"
                    disablePast
                    minDate={tomorrow}
                    value={deadline ? dayjs(deadline) : null}
                    // onChange={(newValue) => setDeadline(newValue?.toISOString())}
                    // onChange={(newValue) => setDeadline(newValue?.format('YYYY-MM-DD'))}
                    onChange={(newValue) => setAppropriateDate(newValue?.format('YYYY-MM-DD'))}
                /> */}


                <DatePicker
                  label="Interview deadline (MM/DD/YY) 11"
                  disablePast
                  minDate={tomorrow}
                  value={deadline ? dayjs(deadline) : null}
                  onChange={(newValue) =>
                    setAppropriateDate(
                      newValue ? newValue.startOf('day').toISOString() : null
                    )
                  }
                />

            </LocalizationProvider>
        </Box>
        <Typography variant='h2' sx={{pt: '48px', textAlign: 'center', pb: '16px'}}>Let's start from somewhere</Typography>
        <Box sx={{display: 'flex', gap: '20px', justifyContent: 'center'}}>
            {!shouldHideAdvancedGenerator && (
                <AdvancedInterview>
                    <AndroidIcon />
                    <Typography variant='h2' sx={{lineHeight: '32px'}}>Do you want to use our advanced interview generator?</Typography>
                    <Typography variant='body1' sx={{color: 'var(--Interviewer-Lighter-Black)', pb: '24px', pt: '12px'}}>A short description about advanced interview generator goes here.</Typography>
                    <Button 
                        variant="contained" 
                        color="primary"
                        onClick={handleAdvancedGeneratorClick}
                        fullWidth
                    >
                        Use advanced interview generator
                    </Button>
                </AdvancedInterview>
            )}
            {!shouldHideFromScratch && (
                <FromScratchInterview>
                    <AndroidIcon />
                    <Typography variant='h2' sx={{lineHeight: '32px'}}>Make your interview from scratch</Typography>
                    <Typography variant='body1' sx={{color: 'var(--Interviewer-Lighter-Black)', pb: '24px', pt: '12px'}}>A short description about making an interview from scratch here.</Typography>
                    <Button variant="contained" color="primary" fullWidth onClick={() => handleFromScratchClick()}>Make an interview from scartch</Button>
                </FromScratchInterview>
            )}
        </Box>
       

        {!shouldHideFromScratch && (
            <>
              <Divider 
                  orientation="horizontal" 
                  sx={{borderColor: 'var(--Interviewer-Near-White)',
                  my: '56px'}} 
              />
              <Typography variant='h2' sx={{pb: '32px', textAlign: 'center'}}>Other Android Interviews already created.</Typography>

              {isLoadingInterviews && <Typography>Loading interviews...</Typography>}
              {errorInterviews && <NoData />}
              {interviews?.map((interview) => (
                  <Box key={interview.id} sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      backgroundColor: '#fff',
                      border: '1px solid var(--Light-Gray)',
                      borderRadius: '12px',
                      padding: '12px',
                      mb: '16px',
                      cursor: 'pointer',
                      '&:hover': { backgroundColor: 'var(--Interviewer-Near-White)' }
                  }} onClick={() => handlePredefinedInterviewClick(interview)}>
                      <Box sx={{display: 'flex', alignItems: 'center', gap: '16px'}}>
                          <AndroidIcon />
                          <Typography variant='h4' sx={{fontWeight: '600'}}>{interview.name}</Typography>
                      </Box>

                      <Box sx={{display: 'flex', alignItems: 'center', gap: '16px'}}>
                          <Box sx={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                              <Typography variant='h5' sx={{color: 'var(--Interviewer-Lightest-Black)', fontWeight: '600'}}>Created on</Typography>
                              <Typography variant='h4' sx={{color: 'var(--Interviewer-Black)', fontWeight: '600'}}>
                                  {new Date(interview.createdOn).toLocaleDateString('en-US', { 
                                      year: 'numeric', 
                                      month: 'long', 
                                      day: 'numeric' 
                                  })}
                              </Typography>
                          </Box>
                          <KeyboardArrowRightIcon />
                      </Box>
                  </Box>
              ))}
            </>
        )}
    </Box>
  )
}